<template>
  <div class="wrapper">
    <ul class="yardList" v-if="showIf">
      <li class="title">院区列表</li>
      <li @click="push(item)" v-for="item in yardList" :key="item.hspCode">
        <ul class="content">
          <li class="name">{{item.hspName}}</li>
          <li class="grade">
            <span v-for="it in item.slogan" :key="it">{{it}}</span>
          </li>
          <li class="phone_area">
            <span style="margin-bottom: 14px;">
              <img src="@/assets/brief/phone2.png" />
              <span>{{item.phone}}</span>
              <a class="callphone" @click.stop="clear(item.phone)" >
                <van-icon name="phone-o" />
              </a>
            </span>
            <span>
              <img src="@/assets/brief/area.png" />
              <span>{{item.address}}</span>
              <a class="callphone" @click.stop="clear2(item.hspCode)" >
                <van-icon name="location-o" />
              </a>
            </span>
            <!-- <a class="callphone" @click.stop="clear(item.phone)" >
              <img src="@/assets/brief/phone1.png" />
              <van-icon name="phone-o" />
            </a> -->
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { selectBHosptialinfo, GetHosptal } from "@/request/api.js"
import { GridItem } from 'vant';
export default {
  data() {
    return {
      value: "",
      showIf: true,
      yardList: []
    };
  },
  async created() {
    let res = await selectBHosptialinfo();
    this.yardList = res.data.obj;
    this.yardList.forEach(el => {
      el.slogan = el.slogan.split('，')
    });
    let res2 = await GetHosptal();
    console.log(res2.data.obj)
  },
  methods: {
    handleQuery() {
      if (this.value) {
        this.showIf = false;
      } else {
        this.showIf = true;
      }
    },
    push(item) {
      sessionStorage.setItem("YardDetails",JSON.stringify(item))
      this.$router.push("/YardBrief/YardDetails");
    },
    clear(phone){
      window.location.href = `tel://${phone}`;
    },
    clear2(hspCode){
      this.$router.push(`/CollegesDepartments?${hspCode}`);
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  .content {
    flex: 1;
    display: flex;
    flex-flow: column nowrap;
    letter-spacing: 1px;
    .name {
      font-size: 17px;
      font-weight: bold;
    }
    .grade {
      margin: 14px 0px 22px;
      font-size: 14px;
      > span {
        color: #2a9dce;
        margin-right: 4px;
        padding: 3px 7px;
        border: 1px solid #2a9dce;
        border-radius: 3px;
      }
    }
    .phone_area {
      position: relative;
      display: flex;
      flex-flow: column nowrap;
      font-size: 16px;
      color: #bebebe;
      padding-bottom: 10px;
      > span {
        position: relative;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        align-items: center;
        > img {
          width: 21px;
          height: 27px;
        }
        > span {
          margin-left: 6px;
          width: 84%;
        }
        .callphone {
          position: absolute;
          right: 0px;
          background: #2a9dce;
          color: #FFF;
          font-size: 20px;
          border-radius: 50%;
          padding: 4px 4px 0px 6px;
        }
      }
      // .callphone {
      //   position: absolute;
      //   top: -7px;
      //   right: 0px;
      //   width: 32px;
      //   height: 32px;
      //   > img {
      //     width: 32px;
      //     height: 32px;
      //   }
      // }
    }
    .details {
      > p {
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 600;
      }
      > span {
        line-height: 25px;
        font-size: 14px;
        color: #707070;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
  .yardList{
    flex: 1;
    margin-top: 10px;
    background-color: #FFF;
    display: flex;
    flex-flow: column nowrap;
    >li{
      padding: 20px;
      border: 1px solid #eee;
      display: flex;
      flex-flow: row nowrap;
    }
    .title{
      font-weight: bold;
      font-size: 18px;
      padding: 10px 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/website/YardBrief/YardBrief.vue